import {
  Component,
  ElementRef,
  Input,
  OnChanges,
  OnInit,
  SimpleChanges,
  ViewChild,
} from '@angular/core';
import { DomSanitizer, SafeUrl } from '@angular/platform-browser';

import { CanvasHelper } from '../../helpers/canvas.helper';
import { BboxCoordinates } from '../../features/detection/models/bbox-coordinates';

@Component({
  selector: 'app-image-cropped',
  templateUrl: './image-cropped.component.html',
  styleUrls: ['./image-cropped.component.scss'],
})
export class ImageCroppedComponent implements OnInit, OnChanges {
  @Input() file: Blob;
  @Input() coordinates: BboxCoordinates;
  @ViewChild('canvas') canvas: ElementRef<HTMLCanvasElement>;
  public src: SafeUrl;

  constructor(private domSanitizer: DomSanitizer) {}

  ngOnInit() {}

  ngOnChanges(changes: SimpleChanges) {
    this.drawCrop();
  }

  private drawCrop(): Promise<void> {
    const image = this.file;
    const canvas = this.canvas.nativeElement;
    const { x, y, w, h } = this.coordinates;
    const crop = [x, y, w, h, 0, 0, w, h];
    canvas.width = w;
    canvas.height = h;
    return CanvasHelper.drawImage(canvas, image, true, crop).then(() => {
      canvas.toBlob(blob => {
        this.src = this.blobToSafeUrl(blob);
      });
    });
  }

  private blobToSafeUrl(blob: Blob): SafeUrl {
    const url = URL.createObjectURL(blob);
    return this.domSanitizer.bypassSecurityTrustUrl(url);
  }
}
